<script>
  import { fade } from "svelte/transition";
  import Img from "../../components/Img.svelte";
  import Load from "../../components/Load.svelte";
  import "../../../node_modules/croppie/croppie.css";
  import Croppie from "croppie";
  import Asidetoko from "../../components/Asidetoko.svelte";

  import format from "number-format.js";
  import { redirect } from "../../pager";
  import Alert from "../../components/Alert.svelte";
  import Title from "../../components/Title.svelte";
  import Navigationbar from "../../components/Navigationbar.svelte";
  import FileInput from "../../components/FileInput/FileInput.svelte";
  import Select from "svelte-select";

  //liblary
  import axios from "axios";

  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";

  import { session } from "../../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  export let data;
  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  //navigation
  let navigation = [];
  if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }
  //alert
  let alert = [];
  let itemsDisplay = false;
  let loading = "block";
  let items = [];

  function loadShop() {
    axios
      .get(settings.url + "/sipade/toko", {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        items = response.data;
        itemsDisplay = true;
        loading = "hidden";

        if (data) {
          loadTransaction(data.status);
        } else {
          loadTransaction("all");
        }
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else if (error.response.status == 404) {
          itemsDisplay = true;
          loading = "hidden";
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      });
  }
  loadShop();
  let itemsOrderDisplay = false;
  let loadOrder = "block";
  let itemsOrder = [];
  let itemsNotif = [];

  function loadTransaction(status = "all") {
    axios
      .get(settings.url + "/sipade/transaction/" + status, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        itemsNotif = response.data.count;
        itemsOrder = response.data.data;
        itemsOrderDisplay = true;
        loadOrder = "hidden";
        setTimeout(() => {
          btnfilterActivate(status);
        }, 500);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }

  function statusUpdate(id, status) {
    axios
      .post(
        settings.url + "/sipade/orderstatus?authorization=" + settings.token,
        {
          transactionID: id,
          status: status,
        }
      )
      .then(function (response) {
        loadTransaction("all");
      })
      .catch(function (error) {
        window.location.reload();
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        }
      });
  }

  function btnfilterActivate(id) {
    Array.from(document.getElementsByClassName("btnfilter")).forEach((el) => {
      el.classList.remove("font-bold");
    });
    if (id) {
      document.getElementById("btnfilter-" + id).classList.add("font-bold");
    } else {
      this.classList.add("font-bold");
    }
  }

  let step = 1;
  function nextStep() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    if (document.getElementsByClassName("tablist").length >= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step + 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
    }
  }

  function backStep() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    if (document.getElementsByClassName("tablist").length <= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step - 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
    }
  }

  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }

  //FORM ADD STORE

  let lat = "-6.6894830820344895";
  let long = "106.87940311589048";

  let image1source = false;
  let categories = [];
  let require;
  $: require = {
    image1: false,
    namatoko: "",
    deskripsi: "",
    tokoalamat: "",
    area: undefined,
    tokolat: "",
    tokolong: "",
    telp: "",
  };

  let number;
  $: number = {
    telp: require.telp,
  };
  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  async function handleSubmit(event) {
    let valid = validator();
    if (valid) {
      axios
        .post(settings.url + "/sipade/toko?authorization=" + settings.token, {
          description: require.deskripsi,
          nameShop: require.namatoko,
          area: require.area.kode,
          avatar: require.image1,
          address_name: require.tokoalamat,
          lat: require.tokolat,
          long: require.tokolong,
          telp: require.telp,
        })
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: response.data.message,
              color: "green",
            },
          ];

          setTimeout(() => {
            loadShop();
          }, 3000);
        })
        .catch(function (error) {
          backStep();

          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        });
    } else {
      console.error("belum terisi dengan benar");

      alert = [
        {
          title: "Dekatan",
          message: "Ada kolom yang belum Terisi dengan benar",
          color: "orange",
        },
      ];
    }
  }

  function SetImage() {
    if (require.image1) {
      document.getElementById("imgTumb1").innerHTML =
        '<img alt="logo" class="object-contain rounded-lg" src="' +
        require.image1 +
        '">';
      document.getElementById("image-blank-1").style.display = "none";
      document.getElementById("image-fill-1").style.display = "block";
    } else {
      document.getElementById("imgTumb1").innerHTML = " ";
      document.getElementById("image-blank-1").style.display = "block";
      document.getElementById("image-fill-1").style.display = "none";
    }
  }

  let cropCrop;
  let binaryData;
  let orientation = 1;
  let cropEl = document.getElementById("imgCrop");

  let cropImage = "1";

  function destroyCrop() {
    if (!cropCrop) return;
    cropCrop.destroy();
    cropCrop = null;
  }

  function initCrop() {
    if (cropCrop) return;

    cropCrop = new Croppie(document.querySelector("#imgCrop"), {
      viewport: { width: 300, height: 300 },
      boundary: { width: "100%", height: "70vh" },
      showZoomer: true,
      enableOrientation: true,
    });
  }

  function handleFileSelect(file) {
    var f = file.detail.files[0]; // FileList object
    if (f) {
      if (/(jpe?g|png|gif)$/i.test(f.type)) {
        if (f.size > 10292969) {
          alert = [
            ...alert,
            {
              message: "File yang dapat diproses maks 300Kb",
              color: "orange",
            },
          ];
        } else {
          var reader = new FileReader();

          // Closure to capture the file information.
          reader.onload = (function (theFile) {
            return function (e) {
              binaryData = e.target.result;
              if (cropImage == "1") {
                image1source = binaryData;
              }

              document.getElementById("imgCropModal").style.display = "block";
              SetImage();
              cropEl = document.getElementById("imgCrop");

              cropEl.style.display = "block";
              document.getElementById("imgCropmenu").style.display = "block";
              initCrop();

              cropCrop.bind({ zoom: 0, url: binaryData });

              document.getElementById(
                "image-blank-" + cropImage
              ).style.display = "none";
              document.getElementById("image-fill-" + cropImage).style.display =
                "block";
            };
          })(f);
          reader.readAsDataURL(f);
        }
      } else {
        alert = [
          ...alert,
          {
            message: "File yang dapat diproses berupa .jpg,jpeg,png,gif",
            color: "orange",
          },
        ];
      }
    } else {
      alert = [
        ...alert,
        {
          message: "File tidak ditemukan",
          color: "orange",
        },
      ];
    }
  }
  function cropRotateR() {
    cropCrop.rotate(90);
  }
  function cropRotateL() {
    cropCrop.rotate(-90);
  }
  function cropFlipx() {
    orientation = orientation == 1 ? 2 : 1;
    cropCrop.bind({ zoom: 0, url: binaryData, orientation: orientation });
  }
  function cropFlipy() {
    orientation = orientation == 1 ? 4 : 1;
    cropCrop.bind({ zoom: 0, url: binaryData, orientation: orientation });
  }
  let cropRes;
  function cropResult() {
    cropCrop
      .result({
        type: "base64",
        format: "png",
        size: { width: 600, height: 600, quality: 1 },
      })
      .then(function (imgcroped) {
        cropRes = imgcroped;
        if (cropImage == "1") {
          require.image1 = cropRes;
        }
        SetImage();
        document.getElementById("imgCropModal").style.display = "none";

        destroyCrop();
      });
  }

  let cropDisplay = "block";
  let cropmenuDisplay = "flex";
  function cropClose() {
    cropEl.style.display = "none";
    document.getElementById("imgCropModal").style.display = "none";
    initCrop();
  }

  function cropCloseX() {
    cropEl.style.display = "none";
    document.getElementById("imgCropModal").style.display = "none";
    SetImage();
  }
  function cropOpen() {
    cropEl.style.display = "block";
    document.getElementById("imgCropModal").style.display = "block";
    initCrop();
    if (cropImage == "1") {
      cropCrop.bind({ zoom: 0, url: image1source });
    }
  }

  $: lengthCount = require.namatoko.length;

  $: lengthDescriptionCount = require.deskripsi.length;
  $: lengthAlamatCount = require.tokoalamat.length;

  import Item from "../../components/select/Item.svelte";
  import loadOptions from "../../components/select/area.js";

  const optionIdentifier = "id";
  const getOptionLabel = (option) => option.desa;
  const getSelectionLabel = (option) =>
    option.desa + " " + option.kec + " " + option.kab + " - " + option.prov;

  import "leaflet/dist/leaflet.css";

  let L = window.L;
  let div = "map";
  function validateLatLng(latitude, longtitude) {
    if (latitude == "" || longtitude == "") {
      alert = [
        ...alert,
        {
          title: "Dekatan",
          message: "Kordinat Masih Kosong",
          color: "orange",
        },
      ];
      return false;
    } else {
      if (isFinite(latitude) && Math.abs(latitude) <= 90) {
        if (isFinite(longtitude) && Math.abs(longtitude) <= 180) {
          return true;
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Kordinat Longtitude Tidak Valid",
              color: "orange",
            },
          ];
          return false;
        }
      } else {
        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: "Kordinat Latitude Tidak Valid",
            color: "orange",
          },
        ];
        return false;
      }
    }
  }
  function addMapPicker(setCenter) {
    if (validateLatLng(require.tokolat, require.tokolong)) {
      document.getElementById("contmap").innerHTML = "";
      document.getElementById("contmap").style.display = "block";
      document.getElementById("contmap").innerHTML =
        "<div id='map' style='width: 100%; height: 100%;'></div>";
      let mapCenter = [require.tokolat, require.tokolong];
      var map = L.map(div, { center: mapCenter, zoom: 15 });
      L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        maxZoom: 18,
        attribution:
          '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
        id: "PositionPicker",
        noWrap: true,
      }).addTo(map);
      var marker = L.marker(mapCenter, {
        draggable: true,
      }).addTo(map);
      marker.bindPopup("Geser Hingga Sesuai").openPopup();
      function updateMarker(lat, lng) {
        axios
          .get(
            "https://shipper.id/bos/geodata/json_map_area?latlng=" +
              lat +
              "," +
              lng
          )
          .then(function (response) {
            marker
              .bindPopup(response.data.geocode.formatted_address)
              .openPopup();
          })
          .catch(function (error) {
            marker.bindPopup("Geser Hingga Sesuai").openPopup();
          });
        return false;
      }

      marker.on("drag", function (e) {});
      marker.on("dragstart", function (e) {});
      marker.on("dragend", function (e) {
        require.tokolat = e.target._latlng.lat;
        require.tokolong = e.target._latlng.lng;
        map.panTo([e.target._latlng.lat, e.target._latlng.lng]);
        updateMarker(e.target._latlng.lat, e.target._latlng.lng);
      });
    }
  }

  function getLocation() {
    navigator.geolocation.getCurrentPosition(
      displayLocationInfo,
      handleLocationError,
      { maximumAge: 1500000, timeout: 0, enableHighAccuracy: true }
    );
  }
  function displayLocationInfo(position) {
    require.tokolat = position.coords.latitude;
    require.tokolong = position.coords.longitude;
    console.log(
      "display:" + position.coords.latitude + "," + position.coords.longitude
    );
    addMapPicker();
  }

  function handleLocationError(error) {
    switch (error.code) {
      case 3:
        // timeout was hit, meaning nothing's in the cache
        // let's provide a default location:
        displayLocationInfo({ coords: { longitude: long, latitude: lat } });

        // now let's make a non-cached request to get the actual position
        navigator.geolocation.getCurrentPosition(
          displayLocationInfo,
          handleLocationError
        );
        break;
      case 2:
        // ...
        break;
      case 1:
      // ...
    }
  }
  function displayLocationbySelect(lat, long) {
    require.tokolat = lat;
    require.tokolong = long;
    addMapPicker();
  }
  function handleSelect(selectedVal) {
    console.log(selectedVal);
    displayLocationbySelect(selectedVal.detail.lat, selectedVal.detail.lang);
  }
</script>

<svelte:head>
  <title>Jualan Ke Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

{#if items.data}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title={items.data.nameShop}
    filter="true"
    filtercustom="<span>Menu</span>"
  />
{:else}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title="Buat Toko Anda"
  />
{/if}

<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  {#if itemsDisplay}
    {#if items.data}
      <div class="flex flex-wrap items-center px-3 mx-auto center">
        <div
          class="flex flex-wrap items-center justify-between w-full h-auto p-3 bg-white rounded-lg shadow-lg lg:w-3/6 lg:h-56 lg:p-10 lg:py-3 lg:my-0 lg:rounded-br-none lg:rounded-tl-full lg:relative"
        >
          <div
            class="fixed bottom-0 right-0 z-10 w-10 mb-5 mr-5 lg:z-auto md:z-auto lg:absolute lg:right-0 lg:top-0 lg:mt-20 lg:-mr-5"
          >
            {#if items.owner}
              <a
                href="./tokoku/add"
                class="flex items-center justify-center w-10 h-10 text-xl text-center text-white bg-blue-600 rounded-full shadow-md lg:w-auto md:w-auto focus:bg-gray-500 focus:outline-none hover:bg-blue-400"
                >+</a
              >
            {/if}
            <a
              on:click|preventDefault={() =>
                document.getElementById("share").classList.toggle("hidden")}
              href="./belanja/{items.data.domain}"
              class="relative flex items-center justify-center w-10 h-10 p-2 my-2 text-xs text-center text-white bg-gray-200 rounded-full shadow-md lg:w-auto md:w-auto focus:bg-gray-200 focus:outline-none hover:bg-gray-100"
              ><img alt="share" title="Bagikan" src="assets/svg/share.svg" />
              <div
                id="share"
                class="absolute bottom-0 right-0 hidden w-auto p-2 px-4 mb-12 text-gray-700 bg-white border-2 border-gray-200 rounded-lg shadow-lg"
              >
                <div class="pb-2 text-xs bg-white">Bagikan</div>
                <div class="flex w-full gap-2">
                  <span
                    on:click={() =>
                      window.open(
                        "https://web.facebook.com/sharer/sharer.php?u=" +
                          encodeURIComponent(
                            "https://app.dekatan.com/#!/belanja/" +
                              items.data.domain
                          ),
                        "_blank"
                      )}
                    class="flex items-center justify-center w-12 h-12 overflow-hidden bg-gray-200 rounded-lg shadow-none focus:shadow-none lg:w-8 md:w-10 lg:h-8 md:h-10 hover:shadow-md"
                    ><img
                      alt="fb"
                      title="Bagikan ke Facebook"
                      src="assets/svg/fb.svg"
                    /></span
                  >
                  <span
                    on:click={() =>
                      window.open(
                        "https://twitter.com/intent/tweet?text=&url=" +
                          encodeURIComponent(
                            "https://app.dekatan.com/#!/belanja/" +
                              items.data.domain
                          ),
                        "_blank"
                      )}
                    class="flex items-center justify-center w-12 h-12 overflow-hidden bg-gray-200 rounded-lg shadow-none focus:shadow-none lg:w-8 md:w-10 lg:h-8 md:h-10 hover:shadow-md"
                    ><img
                      alt="tw"
                      title="Bagikan ke Twitter"
                      src="assets/svg/twitter.svg"
                    /></span
                  >
                  <span
                    on:click={() =>
                      window.open(
                        "https://api.whatsapp.com/send?text=" +
                          encodeURIComponent(
                            "https://app.dekatan.com/#!/belanja/" +
                              items.data.domain
                          ),
                        "_blank"
                      )}
                    class="flex items-center justify-center w-12 h-12 overflow-hidden bg-gray-200 rounded-lg shadow-none focus:shadow-none lg:w-8 md:w-10 lg:h-8 md:h-10 hover:shadow-md"
                    ><img
                      alt="wa"
                      title="Bagikan ke WhatsApp"
                      src="assets/svg/wa.svg"
                    /></span
                  >
                </div>
              </div></a
            >
          </div>
          <div
            class="flex items-center w-full h-full text-center lg:w-full md:w-4/6"
          >
            <div
              class="w-4/12 h-auto p-2 overflow-hidden lg:w-2/12 md:w-1/6 lg:-mt-10 lg:-ml-8"
            >
              {#if items.data.avatar != 0}
                <Img
                  csscont="none"
                  showplaceholder="false"
                  id={items.data.nameShop}
                  datasrc="https://pics.dekatan.com/shop/{items.data.avatar}"
                  alt={items.data.nameShop}
                  css="bg-gray-300 border-4 border-white rounded-full shadow-md"
                />
              {:else}
                <img
                  id={items.data.nameShop}
                  src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"
                  alt={items.data.nameShop}
                  class="bg-gray-300 border-4 border-white rounded-full shadow-md"
                />
              {/if}
            </div>
            <div class="w-4/5 p-2 text-left lg:w-5/6 md:w-5/6">
              <a href="/belanja/{items.data.domain}" class="text-xl font-bold"
                >{items.data.nameShop}</a
              >
              <p class="text-sm font-light text-gray-600">
                {items.data.description}
              </p>
              <span class="text-sm font-light text-blue-600"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  class="inline"
                  ><defs>
                    <path
                      id="a"
                      d="M12 12.209a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-.001-10.21C8.072 2 5 4.968 5 8.785c0 4.837 4.446 10.154 6.251 12.1a1.01 1.01 0 0 0 1.491-.005C14.545 18.916 19 13.62 19 8.644 19 5.159 16.16 2 11.999 2"
                    />
                  </defs>
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <mask id="b" fill="#fff">
                      <use xlink:href="#a" />
                    </mask>
                    <use fill="#9FA6B0" xlink:href="#a" />
                    <g fill="#6C727C" fill-rule="nonzero" mask="url(#b)">
                      <path d="M1 1h22v22H1z" />
                    </g>
                  </g></svg
                >
                {items.data.location}</span
              >
            </div>
          </div>
        </div>
        <div
          class="w-full overflow-hidden text-center rounded-r-lg shadow-lg lg:w-3/6"
        >
          <div
            class="flex-row items-center justify-center hidden w-full h-56 mx-auto overflow-hidden bg-gray-300 rounded-t-lg rounded-r-lg lg:flex md:hidden"
          >
            <Img
              csscont="none"
              showplaceholder="false"
              id={items.data.nameShop}
              datasrc="https://pics.dekatan.com/{items.data.cover}"
              alt={items.data.nameShop}
            />
          </div>
        </div>
      </div>

      <div class="flex">
        {#if items.data}
          <Asidetoko href="/belanja/{items.data.domain}" />
        {:else}
          <Asidetoko />
        {/if}
        <div class="w-full px-2 mx-auto lg:my-5">
          {#if itemsOrderDisplay}
            <div
              class="w-full p-2 mt-5 overflow-x-auto bg-white rounded-lg shadow"
            >
              <div class="flex justify-between text-xs">
                <span
                  class="flex items-center justify-center px-4 my-2 text-lg font-bold text-gray-800"
                  >Status</span
                >
                <a
                  on:click={() => loadTransaction("all")}
                  id="btnfilter-all"
                  class="w-1/2 px-4 py-2 mx-1 my-1 font-bold text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/all"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Semua Transaksi
                  </div>
                </a>
                <a
                  on:click={() => loadTransaction("0")}
                  id="btnfilter-0"
                  class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/0"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Pesanan Baru
                    {#if itemsNotif.status_0_res.counter > 0}
                      <span
                        class="absolute top-0 right-0 px-2 -mt-3 -mr-3 text-white bg-red-500 rounded-full"
                        >{itemsNotif.status_0_res.counter}</span
                      >
                    {/if}
                  </div>
                </a>
                <a
                  on:click={() => loadTransaction("100")}
                  id="btnfilter-100"
                  class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/100"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Pesanan Diproses
                    {#if itemsNotif.status_100_res.counter > 0}
                      <span
                        class="absolute top-0 right-0 px-2 -mt-3 -mr-3 text-white bg-red-500 rounded-full"
                        >{itemsNotif.status_100_res.counter}</span
                      >
                    {/if}
                  </div>
                </a>
                <a
                  on:click={() => loadTransaction("200")}
                  id="btnfilter-200"
                  class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/200"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Proses Pengiriman
                    {#if itemsNotif.status_200_res.counter > 0}
                      <span
                        class="absolute top-0 right-0 px-2 -mt-3 -mr-3 text-white bg-red-500 rounded-full"
                        >{itemsNotif.status_200_res.counter}</span
                      >
                    {/if}
                  </div>
                </a>
                <a
                  on:click={() => loadTransaction("300")}
                  id="btnfilter-300"
                  class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/300"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Dalam Pengiriman
                    {#if itemsNotif.status_300_res.counter > 0}
                      <span
                        class="absolute top-0 right-0 px-2 -mt-3 -mr-3 text-white bg-red-500 rounded-full"
                        >{itemsNotif.status_300_res.counter}</span
                      >
                    {/if}
                  </div>
                </a>
                <a
                  on:click={() => loadTransaction("400")}
                  id="btnfilter-400"
                  class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/400"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Pesanan Selesai
                    {#if itemsNotif.status_400_res.counter > 0}
                      <span
                        class="absolute top-0 right-0 px-2 -mt-3 -mr-3 text-white bg-red-500 rounded-full"
                        >{itemsNotif.status_400_res.counter}</span
                      >
                    {/if}
                  </div>
                </a>
                <a
                  on:click={() => loadTransaction("500")}
                  id="btnfilter-500"
                  class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/500"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Pesanan Dibatalkan
                    {#if itemsNotif.status_500_res.counter > 0}
                      <span
                        class="absolute top-0 right-0 px-2 -mt-3 -mr-3 text-white bg-red-500 rounded-full"
                        >{itemsNotif.status_500_res.counter}</span
                      >
                    {/if}
                  </div>
                </a>
                <a
                  on:click={() => loadTransaction("600")}
                  id="btnfilter-600"
                  class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-full shadow-md cursor-pointer lg:w-auto btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="/tokoku/transaksi/600"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    Pesanan Dikembalikan
                    {#if itemsNotif.status_600_res.counter > 0}
                      <span
                        class="absolute top-0 right-0 px-2 -mt-3 -mr-3 text-white bg-red-500 rounded-full"
                        >{itemsNotif.status_600_res.counter}</span
                      >
                    {/if}
                  </div>
                </a>
              </div>
            </div>
            <div class="w-full mt-5">
              {#if itemsOrder.length > 0}
                {#each itemsOrder as it}
                  <section
                    class="w-full px-5 py-2 my-5 text-sm bg-white rounded-lg shadow-lg"
                  >
                    <div class="flex justify-between py-2 border-b">
                      <div class="text-xs font-light text-gray-600">
                        <a
                          href="https://wa.me/{it.buyer.hp}"
                          target="_blank"
                          class="inline-block px-2 py-1 text-gray-200 bg-green-500 rounded-full shadow-md cursor-pointer lg:px-4 hover:shadow"
                          >Hubungi
                          <b>Pembeli</b></a
                        >
                      </div>
                      <div class="text-xs font-light text-gray-600">
                        {it.date}
                        WIB<br />
                      </div>

                      <div class="">
                        <div
                          class="px-2 text-xs font-light text-gray-600 bg-green-200 rounded-lg"
                        >
                          {it.pay_method}
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex flex-wrap items-center justify-between py-2 mx-auto lg:my-0"
                    >
                      <div class="overflow-hidden lg:w-4/12">
                        <h2 class="block font-bold text-blue-500">
                          {it.buyer.nama_pen}
                        </h2>
                        <span
                          class="font-light leading-6 text-gray-600 truncate whitespace-pre-wrap"
                          >({it.inv})</span
                        ><br />
                      </div>
                      <div class="px-2 border-l lg:w-2/12">
                        <div class="text-xs">Status</div>
                        <div class="font-bold">
                          {#if it.status == 0}Pesanan Baru{/if}
                          {#if it.status == 100}Pesanan Diproses{/if}
                          {#if it.status == 200}Proses Pengiriman{/if}
                          {#if it.status == 300}Pengiriman Disiapkan{/if}
                          {#if it.status == 301}Penjemputan Paket{/if}
                          {#if it.status == 302}
                            Pengiriman Paket Terkonfirmasi
                          {/if}
                          {#if it.status == 303}Paket Dalam Perjalanan{/if}
                          {#if it.status == 304}Resi Tidak Valid{/if}
                          {#if it.status == 305}Resi Diubah{/if}
                          {#if it.status == 306}Menunggu Pengambilan{/if}
                          {#if it.status == 307}Dikembalikan{/if}
                          {#if it.status == 308}Pesanan Tiba{/if}
                          {#if it.status == 309}Pesanan Dikomplain{/if}
                          {#if it.status == 400}Pesanan Selesai{/if}
                          {#if it.status == 500}Pesanan Dibatalkan{/if}
                          {#if it.status == 600}Pesanan Dikembalikan{/if}
                        </div>
                      </div>
                      <div class="lg:w-2/12">
                        <div class="text-xs">Ongkos Kirim</div>
                        <div class="font-bold">
                          {format("Rp #.###,", it.shipment)}
                        </div>
                      </div>
                      <div class="lg:w-2/12">
                        <div class="px-2">
                          <span class="text-xs">Total Belanja</span>
                          <div class="font-bold text-green-600">
                            {format("Rp #.###,", it.pricing)}
                          </div>
                        </div>
                      </div>
                      <div class="w-full lg:w-2/12">
                        <div class="px-2">
                          <div
                            class="flex justify-center text-xs font-bold text-green-600"
                          >
                            {#if it.status == 0}
                              <!--Pesanan Baru-->
                              <button
                                on:click|preventDefault={() =>
                                  statusUpdate(it.ID, 100)}
                                class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer lg:w-auto md:w-1/4 hover:shadow focus:bg-gray-500 focus:outline-none"
                                ><span>Terima Pesanan</span></button
                              >
                              <button
                                on:click|preventDefault={() =>
                                  statusUpdate(it.ID, 500)}
                                class="w-1/2 px-4 py-2 mx-1 my-1 text-gray-200 bg-red-500 rounded-full shadow-md cursor-pointer lg:w-auto md:w-1/4 hover:shadow focus:bg-gray-500 focus:outline-none"
                                ><span>Tolak Pesanan</span></button
                              >
                            {/if}
                            {#if it.status == 100}
                              <!--Pesanan Diproses-->
                              <button
                                on:click|preventDefault={() =>
                                  statusUpdate(it.ID, 200)}
                                class="w-full px-4 py-2 mx-1 my-1 text-gray-200 bg-blue-500 rounded-full shadow-md cursor-pointer lg:w-auto md:w-1/4 hover:shadow focus:bg-gray-500 focus:outline-none"
                                ><span>Kirim Paket</span></button
                              >
                            {/if}
                            {#if it.status == 200}
                              Menunggu status pengiriman
                            {/if}
                            {#if it.status == 300}Pengiriman Disiapkan{/if}
                            {#if it.status == 301}Penjemputan Paket{/if}
                            {#if it.status == 302}
                              Pengiriman Paket Terkonfirmasi
                            {/if}
                            {#if it.status == 303}Paket Dalam Perjalanan{/if}
                            {#if it.status == 304}Resi Tidak Valid{/if}
                            {#if it.status == 305}Resi Diubah{/if}
                            {#if it.status == 306}Menunggu Pengambilan{/if}
                            {#if it.status == 307}Dikembalikan{/if}
                            {#if it.status == 308}Pesanan Tiba{/if}
                            {#if it.status == 309}Pesanan Dikomplain{/if}
                            {#if it.status == 400}Pesanan Selesai{/if}
                            {#if it.status == 500}Pesanan Dibatalkan{/if}
                            {#if it.status == 600}Pesanan Dikembalikan{/if}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="py-2 border-t body">
                      {#each it.details.products as p}
                        <div class="w-full py-2 border-b">
                          <div>
                            <div class="flex justify-between w-full">
                              <div class="w-16">
                                <Img
                                  csscont="none"
                                  showplaceholder="false"
                                  id={p.details.alias}
                                  datasrc="https://pics.dekatan.com/{p.pictures
                                    .fileName}"
                                  css="rounded-lg shadow"
                                  alt="img-product"
                                />
                              </div>
                              <div class="w-full px-2">
                                <div class="font-bold text-blue-500">
                                  <a
                                    href="./product/{p.details.alias}-{p.details
                                      .ID}">{p.details.name}</a
                                  >
                                </div>
                                <div class="font-light">
                                  <span class="w-full pr-2 text-green-600">
                                    {format("Rp #.###,", p.details.price)}</span
                                  ><span class="w-full text-gray-600"
                                    >{p.quantity}
                                    Produk</span
                                  >
                                </div>
                                {#if p.note}
                                  <div class="font-light">
                                    <span
                                      class="w-full pr-2 font-bold text-red-600"
                                      >( ! )</span
                                    >
                                    <span class="italic">{p.note} </span>
                                  </div>
                                {/if}
                              </div>
                              <div class="w-2/5 px-2 border-l">
                                <div class="text-xs ellipsis-2">
                                  Total Harga Produk
                                </div>
                                <div
                                  class="font-normal text-green-600 lg:font-bold"
                                >
                                  {format("Rp #.###,", p.subtotal)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      {/each}
                    </div>
                  </section>
                {/each}
              {:else}
                <p
                  class="w-full p-5 font-light text-center text-gray-500 bg-white rounded shadow-md"
                >
                  Belum ada pesanan dengan status terpilih
                </p>
              {/if}
            </div>
          {:else}
            <Load />
          {/if}
        </div>
      </div>
    {:else}
      <div
        id="imgCropModal"
        class="fixed bottom-0 left-0 z-50 w-full h-screen bg-gray-200"
        style="display:none"
      >
        <div id="imgCropmenu" class="hidden h-auto m-2">
          <div
            class="flex justify-between px-4 py-2 text-lg font-bold text-center border-b border-gray-400"
          >
            <span class="py-1 text-gray-700">Editor Gambar</span><span
              class="p-1 cursor-pointer"
              on:click={cropCloseX}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M14 12l5.544-5.544c.584-.583.61-1.511.06-2.06-.549-.55-1.476-.523-2.06.06L12.002 10 6.456 4.456c-.583-.583-1.51-.61-2.06-.06-.55.549-.523 1.477.06 2.06L10.001 12l-5.545 5.544c-.583.583-.61 1.511-.06 2.06.55.55 1.477.523 2.06-.06L12.001 14l5.543 5.544c.584.583 1.511.61 2.06.06.55-.549.524-1.477-.06-2.06L14.002 12z"
                  fill="#6C727C"
                /></svg
              ></span
            >
          </div>
          <div id="imgCropmenuhide" class="flex justify-center gap-1 my-2">
            <button
              class="p-2 text-white bg-green-600 rounded"
              on:click={cropResult}
              on:click={destroyCrop}
              on:click={cropClose}>Simpan</button
            >
            <button
              class="p-2 text-white bg-orange-600 rounded"
              on:click={cropRotateR}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M19 12c0 3.9-3.1 7-7 7-3.2 0-6-2.2-6.8-5.2-.1-.5.2-1.1.7-1.2.5-.1 1.1.2 1.2.7v.1C7.8 15.5 9.7 17 12 17c2.8 0 5-2.2 5-5s-2.2-5-5-5c-1.3 0-2.5.5-3.4 1.3l1.2 1.2c.2.2 0 .5-.2.5H5.7c-.2 0-.3-.1-.3-.3V5.8c0-.3.3-.4.5-.2l1.3 1.3C8.5 5.7 10.2 5 12 5c3.9 0 7 3.1 7 7z"
                  fill="#fff"
                /></svg
              ></button
            >
            <button
              class="p-2 text-white bg-orange-600 rounded"
              on:click={cropRotateL}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M5 12c0 3.9 3.1 7 7 7 3.2 0 6-2.2 6.8-5.2.1-.5-.2-1.1-.7-1.2-.5-.1-1.1.2-1.2.7v.1c-.7 2.1-2.6 3.6-4.9 3.6-2.8 0-5-2.2-5-5s2.2-5 5-5c1.3 0 2.5.5 3.4 1.3l-1.2 1.2c-.2.2 0 .5.2.5h3.9c.2 0 .3-.1.3-.3V5.8c0-.3-.3-.4-.5-.2l-1.3 1.3C15.5 5.7 13.8 5 12 5c-3.9 0-7 3.1-7 7z"
                  fill="#fff"
                /></svg
              ></button
            >
            <button
              class="p-2 text-white bg-orange-600 rounded"
              on:click={cropFlipx}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M10 5.2v13.1c0 .4-.4.7-.9.7H4.8c-.6 0-1.1-.5-.9-1L9.5 5.1c.1-.2.5-.1.5.1zm4.5-.1c-.1-.2-.5-.1-.5.1v13.1c0 .4.4.7.9.7h4.3c.6 0 1.1-.5.9-1L14.5 5.1zM12 3c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zm0 4c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5zm0 5c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5zm0 5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5z"
                  fill="#fff"
                /></svg
              ></button
            >
            <button
              class="p-2 text-white bg-orange-600 rounded"
              on:click={cropFlipy}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M18.8 10H5.7c-.4 0-.7-.4-.7-.9V4.8c0-.6.5-1.1 1-.9l12.9 5.6c.2.1.1.5-.1.5zm.1 4.5c.2-.1.1-.5-.1-.5H5.7c-.4 0-.7.4-.7.9v4.3c0 .6.5 1.1 1 .9l12.9-5.6zM21 12c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5zm-4 0c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5zm-5 0c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5zm-5 0c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5z"
                  fill="#fff"
                /></svg
              ></button
            >
          </div>
        </div>
        <div id="imgCrop" class="h-auto" />
      </div>
      <div class="max-w-lg mx-auto rounded-lg">
        <div class="w-full pt-0 mx-auto my-5 lg:pt-5">
          <div class="w-full mx-auto mb-2">
            <ul
              class="pt-5 mt-5 mb-3 list-unstyled multi-steps tablist lg:pt-auto"
            >
              <li role="presentation" id="stepID1" class="active">
                <span class="text-sm">Detail Toko</span>
              </li>
              <li role="presentation" id="stepID2">
                <span class="text-sm">Logo</span>
              </li>
            </ul>
            <div class="p-10 pt-5 bg-white rounded-md shadow-md">
              {#if errorForm}
                {#if errorForm.length > 0}
                  <div
                    class="w-full p-2 mt-4 mb-5 text-sm italic text-red-500 border border-l-4 border-red-500 rounded-lg"
                  >
                    Mohon isi dengan benar,
                    <br />
                    {#each errorForm as e}
                      - Kolom
                      <b
                        >{document.getElementById(e.field + "-labelwarning")
                          .innerText}</b
                      >
                      {e.message}<br />
                    {/each}
                  </div>
                {/if}
              {/if}
              <form
                autocomplete="off"
                class="w-full"
                on:submit|preventDefault={handleSubmit}
              >
                <div id="stepcontID1" class="block stepcontID">
                  <div class="w-full lg:w-auto">
                    <Title
                      subtitle="Langkah pertama adalah mengisi informasi Toko anda"
                      title="Detail Toko"
                      tipe="2"
                    />
                  </div>

                  <section class="mt-8">
                    <label
                      for="namatoko"
                      class="relative block text-sm font-light"
                    >
                      <input
                        maxlength="20"
                        id="namatoko"
                        type="text"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="Nama Toko"
                        bind:value={require.namatoko}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="namatoko-labelwarning"
                        >Nama Toko
                        <span class="my-2 text-xs text-right text-gray-500"
                          >{lengthCount}/20</span
                        ></span
                      >
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="namatoko-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5 paragraphs">
                    <label
                      for="deskripsi"
                      class="relative block text-sm font-light"
                    >
                      <textarea
                        placeholder="Jelaskan tentang toko ini secara singkat padat"
                        maxlength="200"
                        id="deskripsi"
                        class="w-full h-32 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded-lg form-textarea hover:border-blue-400 focus:shadow-none"
                        bind:value={require.deskripsi}
                      />
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="deskripsi-warning"
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="deskripsi-labelwarning"
                        >Tentang Toko
                        <span class="my-2 text-xs text-right text-gray-500"
                          >{lengthDescriptionCount}/200</span
                        ></span
                      >
                    </label>
                  </section>

                  <section class="mt-5">
                    <label for="area" class="relative block text-sm font-light">
                      <div
                        class="text-sm text-gray-800 placeholder-gray-400 themed"
                      >
                        <Select
                          on:select={handleSelect}
                          {loadOptions}
                          {optionIdentifier}
                          {getSelectionLabel}
                          {getOptionLabel}
                          {Item}
                          bind:selectedValue={require.area}
                          noOptionsMessage="Ketikan Nama Desa"
                          placeholder="Ketik Nama Desa 🍺"
                        />
                        <span
                          class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                          id="area-labelwarning">Lokasi Toko</span
                        >
                        <span
                          class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                          id="area-warning"
                        />
                      </div>
                    </label>
                  </section>

                  <section class="mt-5 paragraphs">
                    <label
                      for="tokoalamat"
                      class="relative block text-sm font-light"
                    >
                      <textarea
                        placeholder="Jelaskan tentang toko ini secara singkat padat"
                        maxlength="200"
                        id="tokoalamat"
                        class="w-full h-24 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded-lg form-textarea hover:border-blue-400 focus:shadow-none"
                        bind:value={require.tokoalamat}
                      />
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="tokoalamat-warning"
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="tokoalamat-labelwarning"
                        >Alamat Lengkap
                        <span class="my-2 text-xs text-right text-gray-500"
                          >{lengthAlamatCount}/200</span
                        ></span
                      >
                    </label>
                  </section>

                  <section class="mt-5">
                    <label
                      for="tokolat"
                      class="relative block text-sm font-light"
                    >
                      <input
                        id="tokolat"
                        type="text"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="tokolatitude"
                        bind:value={require.tokolat}
                        on:change={addMapPicker}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="tokolat-labelwarning">latitude</span
                      >
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="tokolat-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label
                      for="tokolong"
                      class="relative block text-sm font-light"
                    >
                      <input
                        id="tokolong"
                        type="text"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="tokolongtitude"
                        bind:value={require.tokolong}
                        on:change={addMapPicker}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="tokolong-labelwarning">Longtitude</span
                      >
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="tokolong-warning"
                      />
                    </label>
                  </section>

                  <section>
                    <span
                      class="px-2 text-xs border rounded cursor-pointer focus:bg-gray-500 focus:outline-none"
                      on:click={addMapPicker}
                    >
                      Buka Peta
                    </span>
                    <span
                      class="px-2 text-xs border rounded cursor-pointer focus:bg-gray-500 focus:outline-none"
                      on:click={getLocation}
                    >
                      Ambil Posisi Saat Ini
                    </span>
                  </section>

                  <div
                    id="contmap"
                    class="sticky w-full my-1 overflow-hidden rounded"
                    style="display:none; height:250px;"
                  >
                    <div id="map" style="width: 100%; height: 100%;" />
                  </div>

                  <section class="mt-5">
                    <label for="telp" class="relative block text-sm font-light">
                      <input
                        autocomplete="off"
                        minlength="10"
                        id="telp"
                        type="text"
                        name="telp"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="628**********"
                        bind:value={require.telp}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                        id="telp-labelwarning"
                        >No. HP/WA <span class="text-xs"
                          >(tanpa awalan + atau 0)</span
                        ></span
                      >
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="telp-warning"
                      />
                    </label>
                  </section>

                  <button
                    type="button"
                    class="w-auto px-5 py-2 my-5 text-gray-100 bg-green-600 rounded text-1xl focus:bg-gray-500 focus:outline-none"
                    on:click={nextStep}
                  >
                    Selanjutnya
                  </button>
                </div>
                <div id="stepcontID2" class="hidden stepcontID">
                  <Title
                    subtitle="Logo membuat toko mudah dikenali"
                    title="Tambahkan Logo"
                    tipe="2"
                  />

                  <div
                    class="relative flex items-center justify-center w-64 mx-auto my-5 overflow-hidden bg-gray-200 border-4 border-gray-300 border-dashed rounded-full"
                    style="height:16rem"
                  >
                    <div
                      id="imgTumb1"
                      class="absolute top-0 left-0 w-full overflow-hidden"
                    />

                    <FileInput
                      let:dragging
                      multiple={true}
                      on:input={handleFileSelect}
                    >
                      <div
                        on:click={() => (cropImage = "1")}
                        on:drop={() => (cropImage = "1")}
                        class="absolute left-0 top-0 text-blue-900 w-full
                          shadow-lg tracking-wide cursor-pointer text-center {!dragging
                          ? 'font-normal text-xs'
                          : 'font-bold text-sm'}"
                        style="height:16rem"
                      >
                        <div
                          style="display:block;"
                          class="absolute w-full h-full pt-20 text-center cursor-pointer"
                          id="image-blank-1"
                        >
                          <svg
                            class="w-8 h-8 mx-auto"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            ><path
                              d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                            /></svg
                          >

                          <span
                            class="font-bold uppercase"
                            id="image1-labelwarning">Logo Toko</span
                          ><br />
                          {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                        </div>

                        <div
                          style="display:none; background:rgba(49, 53, 59, 0.68);"
                          class="absolute w-full h-full py-20 text-center text-white transition-all duration-300 ease-in-out transform rounded-lg opacity-100 lg:opacity-0 md:opacity-0 hover:opacity-100"
                          id="image-fill-1"
                        >
                          <div
                            class="absolute bottom-0 right-0 w-full mb-4 text-center"
                          >
                            <span
                              on:click|preventDefault={() => (cropImage = "1")}
                              on:click|preventDefault={cropOpen}
                              class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="inline"
                                ><rect
                                  width="28"
                                  height="28"
                                  rx="4"
                                  fill="#fff"
                                />
                                <path
                                  d="M23 20H11c-1.7 0-3-1.3-3-3V5h2v12c0 .6.4 1 1 1h12v2z"
                                  fill="#6C727C"
                                />
                                <path
                                  d="M10 8H5v2h5V8zm8 3v5h2v-5c0-1.7-1.3-3-3-3h-5v2h5c.6 0 1 .4 1 1zm2 7h-2v5h2v-5z"
                                  fill="#6C727C"
                                /></svg
                              ></span
                            >
                            <span
                              on:click|preventDefault={() =>
                                (require.image1 = "")}
                              on:click|preventDefault={SetImage}
                              class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="inline"
                                ><rect
                                  width="28"
                                  height="28"
                                  rx="4"
                                  fill="#fff"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M17 6h3c.55 0 1 .45 1 1v1H7V7c0-.55.45-1 1-1h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm-7 17c-1.1 0-2-.9-2-2V9h12v12c0 1.1-.9 2-2 2h-8z"
                                  fill="#6C727C"
                                /></svg
                              ></span
                            >
                          </div>
                          <svg
                            class="w-8 h-8 mx-auto"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            ><path
                              d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                            /></svg
                          >

                          <span class="uppercase">Ganti Gambar</span><br />
                          {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                        </div>
                      </div>
                    </FileInput>
                  </div>
                  <div class="flex justify-between">
                    <button
                      type="button"
                      class="w-auto px-5 py-2 my-5 text-green-600 text-1xl focus:bg-gray-500 focus:outline-none"
                      on:click={backStep}
                    >
                      Kembali
                    </button>
                    <button
                      type="button"
                      class="w-auto px-5 py-2 my-5 text-gray-100 bg-green-600 rounded text-1xl focus:bg-gray-500 focus:outline-none"
                      on:click={loadingBtn}
                      on:click={handleSubmit}
                    >
                      SIMPAN
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    {/if}
  {:else}
    <Load />
  {/if}
</main>

<style>
  .themed {
    --border: 1px solid #a0aec0;
    --borderRadius: 0.25rem;
    --placeholderColor: #e2e8f0;
    --background: #fff;
    --inputFontSize: 0.875rem;
    --borderHoverColor: #63b3ed;
    --borderFocusColor: #63b3ed;
    --placeholderColor: #adb9c8;
    --itemIsActiveBG: #63b3ed;
  }
</style>
